<div class="card-body">
  <h5 class="filters">Filters</h5>
  <form class="bg-light border rounded-lg px-3 pt-2 pb-1 filters" (ngSubmit)="getAlerts()">
    <div class="row">
      <div class="form-group col-md-4">
        <label>Alert name</label>
        <input type="text" class="form-control" [ngClass]="{ 'is-touched': name }"
          name="name" [(ngModel)]="name" (change)="getAlerts()" placeholder="eg: Telco">
      </div>
      <div class="form-group col-md-4">
        <label>Team member</label>
        <select class="form-control" [ngClass]="{ 'is-touched': user }" name="user" [(ngModel)]="user" (change)="getAlerts()">
          <option value="" selected>Any team member</option>
          @for (user of users; track user._id) {
            <option [value]="user._id">{{user.lastName}} {{user.firstName}}</option>
          }
        </select>
      </div>
      <div class="form-group col-md-4">
        <label>Status</label>
        <select class="form-control" [ngClass]="{ 'is-touched': status }" name="status" [(ngModel)]="status" (change)="getAlerts()">
          <option value="">Any status</option>
          <option value="on" selected>On</option>
          <option value="off">Off</option>
        </select>
      </div>
    </div>
  </form>
  <hr>
    @if (!isLoading && alerts?.length === 0) {
      <p>
        Nothing found.
      </p>
    }
    @if (!isLoading && alerts?.length) {
      <p>
        <span class="badge badge-primary">{{count}}</span> results found:
      </p>
    }
    @if (isLoading) {
      <p>
        <app-spinner [condition]="isLoading"></app-spinner>
      </p>
    }
    <div class="row row-cols-1 row-cols-lg-2" [ngClass]="{ 'disabled': isLoading }">
      @for (alert of alerts; track alert._id) {
        <div class="col mb-3">
          <app-alert [alert]="alert" [commissions]="commissions"></app-alert>
        </div>
      }
    </div>
    @if (alerts?.length) {
      <div>
        <app-pagination [isLoading]="isLoading" [count]="count" [perPage]="perPage" [page]="page" eventName="getAlerts"></app-pagination>
        <app-spinner [condition]="isLoading"></app-spinner>
      </div>
    }
  </div>